import { Accordion as Container } from './Accordion';
import { AccordionBody as Body } from './AccordionBody';
import { AccordionHeader as Header } from './AccordionHeader';
import { AccordionItem as Item } from './AccordionItem';
export * from './Accordion.decl';
export var Accordion = {
  Container: Container,
  Body: Body,
  Header: Header,
  Item: Item
};